'use client';

import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Phone } from 'lucide-react';

interface SuccessMessageProps {
  phoneNumber: string;
  handleCallNowClick: (e: React.MouseEvent) => boolean;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ phoneNumber, handleCallNowClick }) => {
  return (
    <div className="text-center py-8">
      <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--color-rr-green)' }}>
        <CheckCircle className="w-8 h-8 text-white" />
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-2">Quote Request Sent!</h3>
      <p className="text-gray-600 mb-6">Thank you! We'll get back to you within 1 hour with a competitive quote.</p>
      <a
        href={`tel:${phoneNumber}`}
        onClick={handleCallNowClick}
        className="inline-flex items-center space-x-2 text-white font-bold py-3 px-6 rounded-xl transition-all duration-300"
        style={{ background: 'var(--gradient-primary)' }}
      >
        <Phone className="w-5 h-5" />
        <span>Or Call Us Now</span>
      </a>
    </div>
  );
};

export default SuccessMessage;